"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("./Text"));
var _color = _interopRequireDefault(require("./styles/color"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/* istanbul ignore next */
var Label = _styledComponents["default"].label.withConfig({
  displayName: "Label",
  componentId: "sc-19k03h9-0"
})(["display:block;position:relative;padding-left:35px;margin-bottom:12px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;:hover input ~ span{border-color:", ";}:hover input:checked ~ span{background-color:", ";border-color:", ";}input:checked ~ span{background-color:", ";border-color:", ";}input:checked ~ span:after{display:block;}span:after{left:6px;top:1px;width:6px;height:12px;border:solid ", ";border-width:0 2px 2px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}"], function (props) {
  return props.disabled ? _color["default"].disabled : _color["default"].darkGray;
}, function (props) {
  return props.disabled ? _color["default"].lightPrimary : _color["default"].infoHover;
}, function (props) {
  return props.disabled ? _color["default"].lightGrey : _color["default"].infoHover;
}, function (props) {
  return props.disabled ? _color["default"].lightPrimary : _color["default"].info;
}, function (props) {
  return props.disabled ? _color["default"].lightGrey : _color["default"].info;
}, function (props) {
  return props.disabled ? _color["default"].lightGrey : _color["default"].white;
});
Label.displayName = 'Label';
var Input = _styledComponents["default"].input.withConfig({
  displayName: "Input",
  componentId: "sc-19k03h9-1"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;"]);
Input.displayName = 'Input';

/* istanbul ignore next */
var Span = _styledComponents["default"].span.withConfig({
  displayName: "Span",
  componentId: "sc-19k03h9-2"
})(["position:absolute;top:0;left:0;height:20px;width:20px;border-radius:4px;background-color:", ";border:1px solid ", ";:after{content:\"\";position:absolute;display:none;}"], function (props) {
  return props.disabled ? _color["default"].lightPrimary : _color["default"].white;
}, _color["default"].disabled);
Span.displayName = 'Span';
var CheckBox = /*#__PURE__*/function (_Component) {
  _inherits(CheckBox, _Component);
  var _super = _createSuper(CheckBox);
  function CheckBox(props) {
    var _this;
    _classCallCheck(this, CheckBox);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      // eslint-disable-line
      _this.setState({
        checked: e.currentTarget.checked
      });
      _this.props.onChange(e.currentTarget.checked);
    });
    _this.state = {
      checked: props.checked
    };
    return _this;
  }

  /* istanbul ignore next */
  _createClass(CheckBox, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.checked !== nextProps.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "getCheckBox",
    value: function getCheckBox() {
      var _this$props = this.props,
        label = _this$props.label,
        disabled = _this$props.disabled;
      var checked = this.state.checked;
      return /*#__PURE__*/_react["default"].createElement(Label, {
        "data-testid": "Label",
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        text: label,
        textSize: "h4",
        fontWeight: "400",
        fontColor: _color["default"].darkestGray,
        lineHeight: "23px"
      }), /*#__PURE__*/_react["default"].createElement(Input, {
        "data-testid": "Input",
        type: "checkbox",
        checked: checked,
        onChange: this.onChange,
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(Span, {
        "data-testid": "Span",
        disabled: disabled
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.getCheckBox();
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return CheckBox;
}(_react.Component);
var _default = CheckBox;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Label, "Label", "/Users/crs/WebstormProjects/michelangelo/src/Components/CheckBox.js");
  reactHotLoader.register(Input, "Input", "/Users/crs/WebstormProjects/michelangelo/src/Components/CheckBox.js");
  reactHotLoader.register(Span, "Span", "/Users/crs/WebstormProjects/michelangelo/src/Components/CheckBox.js");
  reactHotLoader.register(CheckBox, "CheckBox", "/Users/crs/WebstormProjects/michelangelo/src/Components/CheckBox.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/CheckBox.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();